import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the datatable for the casino report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user ID

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} Formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            view: 'datatable', // Datatable view
            id: 'datatable', // ID of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: _('Detalles'), // Tooltip for details column
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                    },
                },
                { id: 'Id', header: 'Id', width: 90, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                {
                    id: 'Username',
                    header: _('Usuario'),
                    width: 70,
                    sort: 'int',
                },
                { id: 'Game', header: _('Juego'), width: 150, sort: 'int' }, // Game column
                {
                    id: 'ProviderName',
                    header: _('Proveedor'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Bets', header: _('Apuestas'), width: 80, sort: 'int' }, // Bets column
                {
                    id: 'Stakes',
                    header: _('Valor'),
                    format: webix.i18n.priceFormat, // Formatting for stakes
                    exportType: 'number',
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Winnings',
                    header: _('Premios'),
                    format: webix.i18n.priceFormat, // Formatting for winnings
                    exportType: 'number',
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Profit',
                    header: _('Ganancias'),
                    format: webix.i18n.priceFormat, // Formatting for profit
                    exportType: 'number',
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Profitness',
                    header: _('Beneficio %'),
                    format: percentFormat, // Formatting for profit percentage
                    width: 100,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport?FromId=' + cur_user + '&',
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('user', true); // Current user ID
        var url = grid.data.url; // URL for data loading

        // Event listener for filtering data
        this.on(this.app, 'casinoReportMachine:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add MinCreatedLocal to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add MaxCreatedLocal to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&FromId=' + cur_user; // Add current user to query
            grid.clearAll(); // Clear existing data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
